import { HttpClient } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { unwrap } from './api-response';
import {
  ApiResponse,
  PublicMerchant,
  PublicPromotion,
  PublicPromotionListItem,
  RegisterCodeResult,
} from './api.types';

@Service()
export class PublicApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}public`;

  merchants(): Observable<PublicMerchant[]> {
    return this.http.get<ApiResponse<PublicMerchant[]>>(`${this.base}/merchants`).pipe(unwrap());
  }

  merchantByCode(code: string): Observable<PublicMerchant> {
    return this.http
      .get<ApiResponse<PublicMerchant>>(
        `${this.base}/merchants/by-code/${encodeURIComponent(code)}`,
      )
      .pipe(unwrap());
  }

  promotions(merchantId: string): Observable<PublicPromotionListItem[]> {
    return this.http
      .get<ApiResponse<PublicPromotionListItem[]>>(`${this.base}/merchants/${merchantId}/promotions`)
      .pipe(unwrap());
  }

  promotion(promotionId: string): Observable<PublicPromotion> {
    return this.http
      .get<ApiResponse<PublicPromotion>>(`${this.base}/promotions/${promotionId}`)
      .pipe(unwrap());
  }

  registerCode(promotionId: string, cardNumber: string): Observable<RegisterCodeResult> {
    return this.http
      .post<ApiResponse<RegisterCodeResult>>(`${this.base}/register/code`, {
        promotionId,
        cardNumber,
      })
      .pipe(unwrap());
  }
}
